import { select, Store } from '@ngrx/store';
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import { AppState } from '../../reducers';
import {
  selectFollowUpInStore,
  selectFollowUpPageLoading,
  selectFollowUpShowInitWaitingMessage,
} from '../_selectors/follow-up.selectors';

export class FollowUpDatasource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectFollowUpPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectFollowUpShowInitWaitingMessage));

    this.store.pipe(select(selectFollowUpInStore)).subscribe((response: QueryResultsModel) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
